import { Skill, SkillCategory } from "../../types/scores.types";

export enum Sort {
  scoreAsc = "scoreAsc",
  scoreDesc = "scoreDesc",
  category = "category",
}
export interface RadarProps {
  skills: Array<Skill>;
  selectedCategory: SkillCategory | undefined;
  handleCategorySelected: (category: SkillCategory | undefined) => void;
  disabledIndices?: Array<number>;
  combineCategories?: boolean;
  profileCirclePercent?: number;
  sort?: Sort;
  diameter?: number;
}
